import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./fonts/IBMPlexSansThai-Regular.ttf";
import "./fonts/IBMPlexSansThai-Bold.ttf";
import "./fonts/IBMPlexSansThai-Light.ttf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
